import React from 'react';

import MarkupsEntityBlockView from './MarkupEntityBlockView';
import useFetchMarkupsForSheets from './useFetchMarkupsForSheets';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { Sheet } from '../types/types';

const MarkupsEntityBlock: ReferencePickerPlugin<Sheet>['EntityBlock'] = ({
  entity: sheetHistory,
  projectId,
  onReferenceClickAnalytics,
  sourceEntityId,
  sourceEntityType,
}) => {
  const { markups, isLoading } = useFetchMarkupsForSheets({
    projectId,
    sheetId: sheetHistory.sheetId,
    sourceEntityId,
    sourceEntityType,
  });

  return (
    <React.Fragment>
      <MarkupsEntityBlockView
        entity={sheetHistory}
        projectId={projectId}
        onReferenceClickAnalytics={onReferenceClickAnalytics}
        sourceEntityType={sourceEntityType}
        isLoading={isLoading}
        markups={markups}
      />
    </React.Fragment>
  );
};

export default MarkupsEntityBlock;
